// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__toast {
  display: none;
  font-size: 13px;
  font-family: "OpenSans-Regular";
  position: fixed;
  z-index: 20;
  top: 4em;
  left: 50%;
  transform: translate(-50%, -50%);
}
.avo__toast.show-toast {
  display: block;
  animation: fadein 0.5s;
}
.avo__toast.close-toast {
  animation: fadeout 0.5s;
}
.avo__toast .message-toast {
  display: flex;
  border-radius: 10px;
  padding: 10px 20px;
  color: white;
  width: -moz-fit-content;
  width: fit-content;
}
.avo__toast .message-toast.default {
  background-color: #2d96be;
}
.avo__toast .message-toast.danger {
  background-color: #f04438;
}
.avo__toast .close-image {
  padding-left: 10px;
}

@keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 4em;
    opacity: 1;
  }
}
@keyframes fadeout {
  from {
    top: 4em;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/commons/toast/toast.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADF;AAGE;EACE,cAAA;EACA,sBAAA;AADJ;AAIE;EACE,uBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;AAHJ;AAKI;EACE,yBCXO;ADQb;AAMI;EACE,yBCDG;ADHT;AAQE;EACE,kBAAA;AANJ;;AAUA;EACE;IACE,MAAA;IACA,UAAA;EAPF;EASA;IACE,QAAA;IACA,UAAA;EAPF;AACF;AAUA;EACE;IACE,QAAA;IACA,UAAA;EARF;EAUA;IACE,MAAA;IACA,UAAA;EARF;AACF","sourcesContent":["@import '../../../styles/color';\n\n.avo__toast {\n  display: none;\n  font-size: 13px;\n  font-family: 'OpenSans-Regular';\n  position: fixed;\n  z-index: 20;\n  top: 4em;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  &.show-toast {\n    display: block;\n    animation: fadein 0.5s;\n  }\n\n  &.close-toast {\n    animation: fadeout 0.5s;\n  }\n\n  .message-toast {\n    display: flex;\n    border-radius: 10px;\n    padding: 10px 20px;\n    color: white;\n    width: fit-content;\n\n    &.default {\n      background-color: $primary-40;\n    }\n\n    &.danger {\n      background-color: $red-60;\n    }\n  }\n\n  .close-image {\n    padding-left: 10px;\n  }\n}\n\n@keyframes fadein {\n  from {\n    top: 0;\n    opacity: 0;\n  }\n  to {\n    top: 4em;\n    opacity: 1;\n  }\n}\n\n@keyframes fadeout {\n  from {\n    top: 4em;\n    opacity: 1;\n  }\n  to {\n    top: 0;\n    opacity: 0;\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
